import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationStart, Router, Params } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { setTheme } from 'ngx-bootstrap/utils';
import { Subscription } from 'rxjs';
import { environment } from '../environments/environment';
import { AuthenticationService } from './core/services/authentication.service';
import { BearerService } from './core/services/bearer-service.service';
import { MiddleServiceService } from './core/services/middle-service.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  private title = 'GestDocut360';
  private cssUrl = 'assets/css/'; // skin-blue.min.css
  private theme: string;

  private shareFileUrl = '/files/';
  private ssoErrorUrl = '/SSOError';
  private ssoUrl = '/SSO';
  private finishSso = '/FinishSSO';

  private urlsNotLogin = [this.shareFileUrl, this.ssoErrorUrl, this.ssoUrl, this.finishSso];

  events: Subscription;

  enMantenimiento = environment.MAINTENANCE;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    public translate: TranslateService,
    public bearerService: BearerService,
    private middleService: MiddleServiceService
  ) {
    this.getLanguage();
    setTheme('bs3');
  }

  @HostListener('document:keyup', ['$event'])
  @HostListener('document:click', ['$event'])
  @HostListener('document:wheel', ['$event'])
  @HostListener('document:mousemove', ['$event'])
  resetTimer() {
    this.authService.resetInactiveUserPeriod();
  }

  ngOnInit() {
    this.events = this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart && (<NavigationStart>event).url) {

        let url = (<NavigationStart>event).url;
        this.events.unsubscribe();

        let clientId = this.redirectToSSODetalleSolicitud(window.location.toString());
        if (this.hasToRedirectSsoAuthentication(url) ||
            (clientId !== undefined && clientId !== '' && clientId !== null)) {
          if (clientId === '') {
            clientId = this.getClientByLocalStorage();
          }
          url = `/SSO?clientId=${clientId}`;
          console.log(url);
          console.log(clientId);
          this.router.getCurrentNavigation().extractedUrl.queryParams = { clientId: clientId };
        }

        if (this.isExternalUrl(url)) {
          this.navigateExternalUrl(url);
          return;
        }
        this.checkLogin();
      }

    });
  }

  private redirectToSSODetalleSolicitud(loc: string): string {
    try {
      if (loc.indexOf('(contenido:detalle') >= 0) {
        const argumentos = loc.substring(loc.indexOf('(contenido:detalle') + 18);
        const argumentosCleared = argumentos.replace(')', '');
        const splitedArgs = argumentosCleared.split('/');
        if (splitedArgs.length <= 1) {
          return '';
        }
        this.middleService.redirectTo = splitedArgs[1];
        return splitedArgs[2];
      }
    } catch (error) {
      console.log(error);
    }
    return '';
  }

  private getClientByLocalStorage(): string {
    return this.bearerService.getBearer().replace('Bearer', '').trim();
  }

  private hasToRedirectSsoAuthentication(url: string): boolean {
    const bearer = this.bearerService.getBearer();
    return !this.isUrlSso(url)
      && (!!bearer && !bearer.startsWith('DocoutBearer'));
  }
  private isUrlSso(url: string): boolean {
    if (!url) { return false; }
    const urlLower = url.toLowerCase();
    return urlLower.startsWith(this.ssoUrl.toLowerCase()) || urlLower.startsWith(this.finishSso.toLowerCase());
  }
  private navigateExternalUrl(url: string) {
    const urlLower = url.toLowerCase();
    if (urlLower.startsWith(this.shareFileUrl.toLowerCase())) {
      this.navigateShareFile(urlLower);
      return;
    }

    if (urlLower.startsWith(this.finishSso.toLowerCase())) {
      this.navigateFinishSsoPage();
      return;
    }
    const queryParams = this.router.getCurrentNavigation().extractedUrl.queryParams;
    if (urlLower.startsWith(this.ssoErrorUrl.toLowerCase())) {
      this.navigateSSOErrorPage(queryParams);
      return;
    }
    if (urlLower.startsWith(this.ssoUrl.toLowerCase())) {
      this.navigateSSO(queryParams);
      return;
    }
  }
  private navigateFinishSsoPage() {
    this.router.navigate(['finishSso']);
  }

  private navigateSSO(queryParams: Params) {
    this.router.navigate(['SSO'], {
      queryParams: {
        clientId: queryParams['clientId'],
        client: queryParams['client'],
        token: queryParams['token']
      }
    });
  }
  private navigateSSOErrorPage(queryParams: Params) {
    this.router.navigate(['error'], { queryParams: { message: queryParams['message'] } });
  }
  private navigateShareFile(url: string) {
    const token = url.toLowerCase().substring(this.shareFileUrl.length);
    this.router.navigate(['files', token]);
  }
  private isExternalUrl(url: string) {
    return this.urlsNotLogin.some(urlNotLogin => url.toLowerCase().startsWith(urlNotLogin.toLowerCase()));
  }


  getLanguage() {
    let userLang = navigator.language.split('-')[0]; // use navigator lang if available
    this.translate.setDefaultLang('es');
    if (localStorage.getItem('idioma') === null) {
      userLang = /(es|en|ca|eu)/gi.test(userLang) ? userLang : 'es';
      localStorage.setItem('idioma', userLang);
    } else {
      userLang = localStorage.getItem('idioma');
    }
    this.translate.use(userLang);

  }

  checkLogin() {
    this.bearerService.setBearer('DocoutBearer ');
    if (this.authService.isLoggedIn() && this.authService.isAuthenticated()) {
      this.authService.SetEnviromentVariables();
    }
  }
}
